export const PROD_ADVISOR_DOMAIN = "advisor.findfaye.com";
export const PROD_MEMBER_DOMAIN = "app.findfaye.com";

export const isMemberDomain = () => {
  const { hostname, port } = window.location;
  return (
    hostname === PROD_MEMBER_DOMAIN ||
    (hostname === "localhost" && port === "2999")
  );
};

export const isAdvisorDomain = () => {
  const { hostname, port } = window.location;
  return (
    hostname === PROD_ADVISOR_DOMAIN ||
    (hostname === "localhost" && port === "3000")
  );
};
